module.exports = __webpack_public_path__ + "img/covidCaseJul11to17-2022KV.3260c4b9.jpg";